export default __webpack_public_path__ + "static/media/Payment-Details.58311ff7.jpg";